const STORAGE_KEY = "sailmate_analytics_consent";

export type ConsentStatus = "granted" | "denied" | null;

const VALID_VALUES: readonly string[] = ["granted", "denied"];

export function getConsent(): ConsentStatus {
  if (typeof window === "undefined" || !window.localStorage) return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === null) return null;
    return VALID_VALUES.includes(raw) ? (raw as "granted" | "denied") : null;
  } catch {
    return null;
  }
}

export function setConsent(status: "granted" | "denied"): void {
  if (typeof window === "undefined" || !window.localStorage) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, status);
  } catch {
    // ignore
  }
}
